import script from "./ExperiencePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperiencePage.vue?vue&type=script&setup=true&lang=js"

import "./ExperiencePage.vue?vue&type=style&index=0&id=b87bc2ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b87bc2ca"]])

export default __exports__